import { apiGet, apiPatch } from './client';
import type {
  RolePermission,
  RolePermissionBatchRequest,
  RolePermissionUpdateDto,
} from '../types/RolePermission';

export function getRolePermissions(): Promise<RolePermission[]> {
  return apiGet<RolePermission[]>('/api/role-permissions');
}

export function saveBatchRolePermissions(
  modified: RolePermissionUpdateDto[],
): Promise<RolePermission[]> {
  return apiPatch<RolePermissionBatchRequest, RolePermission[]>(
    '/api/role-permissions/batch',
    { modified },
  );
}
